import React from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import 'app/modules/account/password-reset/passwordReset.scss';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { login } from 'app/shared/util/utilities';

export interface IModalUpdatePhoneProps extends StateProps, DispatchProps, RouteComponentProps<{ key: any }> {}

export interface IModalUpdatePhoneProps {
  isDisplay: boolean;
  message: string;
}

export interface IModalUpdatePhoneState {}

export class ModalUpdatePhone extends React.Component<IModalUpdatePhoneProps, IModalUpdatePhoneState> {
  state: IModalUpdatePhoneState = {};
  constructor(props) {
    super(props);
  }

  handleClose = () => {
    login(this.props.config);
  };

  render() {
    return (
      <div>
        <Modal isOpen={this.props.isDisplay} toggle={null} centered>
          <ModalHeader style={{ justifyContent: 'center' }}>
            <label style={{ fontWeight: 'bold' }}>Thông báo</label>
          </ModalHeader>
          <ModalBody>
            <label>{this.props.message}</label>
          </ModalBody>
          <ModalFooter>
            <Button className="btn-register" onClick={this.handleClose}>
              Đóng
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = ({ applicationProfile }: IRootState) => ({
  config: applicationProfile.config
});

const mapDispatchToProps = {};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalUpdatePhone);
